import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import PaymentMethod from './PaymentMethod';

/**
 * Componente responsável por listar as formas de pagamento.
 */
const PaymentMethodSelect = (props) => {
  
  const { t } = useTranslation();
  // onlyMethods restringe a lista a algumas formas, na ordem padrão (ex.: o pagamento do
  // colaborador, que só sai em dinheiro ou Pix).
  const { value, onChange, error, shortCardLabels = false, hideSubscription = false, onlySubscription = false, showCourtesy = false, onlyMethods = null } = props;
  let options = [
    { value: PaymentMethod.CASH, label: t('cash') },
    { value: PaymentMethod.CREDIT_CARD, label: shortCardLabels ? t('credit_card_short') : t('credit_card') },
    { value: PaymentMethod.DEBIT_CARD, label: shortCardLabels ? t('debit_card_short') : t('debit_card') },
    { value: PaymentMethod.PIX, label: t('pix') },
    ...(showCourtesy ? [{ value: PaymentMethod.COURTESY, label: t('courtesy') }] : []),
    { value: PaymentMethod.SUBSCRIPTION, label: t('subscription') },
  ];

  if (hideSubscription) {
      options = options.filter(o => o.value !== PaymentMethod.SUBSCRIPTION);
  } else if (onlySubscription) {
      options = options.filter(o => o.value === PaymentMethod.SUBSCRIPTION);
  }

  if (onlyMethods) {
      options = options.filter(o => onlyMethods.includes(o.value));
  }

  return (
    <CustomSelect options={options} value={value} onChange={onChange} isClearable placeholder={t("select")} error={error}/>
  )
}

export default PaymentMethodSelect;
